(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gems-core-charge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gems-core-charge')) {
    customElements.define('gems-core-charge', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        if (this.dataset.coreSurface !== 'selection') return;
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), {once:true, signal:this.controller.signal});
        } else this.initialize();
      }
      initialize() {
        const signal = this.controller.signal;
        this.section = this.closest('.product_template');
        this.mainForm = this.closest('form');
        this.master = this.querySelector('select[name="id"]');
        this.option = this.querySelector('.single-option-selector');
        this.dialog = this.querySelector('dialog');
        if (!this.section || !this.mainForm || !this.master || !this.option) return;
        this.selectedId = this.dataset.coreId;
        this.addEventListener('pointerdown', () => {
          this.dataset.coreFocusMode = 'pointer';
        }, {capture:true, signal});
        document.addEventListener('keydown', event => {
          if (!event.altKey && !event.ctrlKey && !event.metaKey && ['Tab', 'Enter', ' ', 'Escape'].includes(event.key)) {
            this.dataset.coreFocusMode = 'keyboard';
          }
        }, {capture:true, signal});
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.matches('[data-core-open]')) this.dialog?.showModal();
          if (button.matches('[data-core-cancel]')) this.dialog?.close();
          if (button.matches('[data-core-confirm]') && this.dialog?.open) {
            const returned = Array.from(this.master.options).find(option => option.value !== this.dataset.coreId && option.dataset.available === 'true');
            if (returned) this.selectVariant(returned.value);
            this.dialog.close();
            this.querySelector('[data-core-restore]')?.focus({preventScroll:true});
          }
          if (button.matches('[data-core-restore]')) {
            this.selectVariant(this.dataset.coreId);
            this.querySelector('[data-core-open]')?.focus({preventScroll:true});
          }
        }, {signal});
        this.dialog?.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, {signal});
        const guard = event => {
          const form = event.target.closest('form');
          if (!this.forms().includes(form)) return;
          const input = form.querySelector('[name="id"]');
          if (!this.currentChoice()?.dataset.available || this.currentChoice().dataset.available !== 'true' || input?.value !== this.selectedId) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.synchronize();
            this.querySelector('[data-core-error]').hidden = false;
          }
        };
        this.section.addEventListener('submit', guard, {capture:true, signal});
        this.section.addEventListener('click', event => {
          if (event.target.closest('[type="submit"], [data-sticky-btn-addToCart], .product-form__cart-submit')) guard(event);
          if (event.target.closest('[data-sticky-add-to-cart] .pr-swatch')) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, {capture:true, signal});
        this.mainForm.addEventListener('change', event => {
          if (event.target === this.option || event.target === this.master) this.synchronize();
        }, {capture:true, signal});
        this.synchronize();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.synchronize(), {once:true, signal});
        window.addEventListener('pageshow', () => this.synchronize(), {signal});
        if (this.section.dataset.enableHistoryState === 'true') {
          const url = new URL(window.location.href);
          if (url.searchParams.has('variant') && url.searchParams.get('variant') !== this.selectedId) {
            url.searchParams.set('variant', this.selectedId);
            url.searchParams.delete('option_values');
            window.history.replaceState(window.history.state, '', url);
          }
        }
      }
      forms() { return [this.mainForm, this.section.querySelector('#form-sticky')].filter(Boolean); }
      currentChoice() { return Array.from(this.master.options).find(option => option.value === this.selectedId); }
      selectVariant(id) {
        this.selectedId = id;
        this.synchronize();
        this.option.dispatchEvent(new Event('change', {bubbles:true}));
        this.synchronize();
        this.querySelector('[data-core-error]').hidden = true;
        const choice = this.currentChoice();
        this.querySelector('[data-core-status]').textContent = `${choice.dataset.summary}. ${choice.dataset.formattedPrice}`;
      }
      synchronize() {
        const choice = this.currentChoice();
        if (!choice) return;
        // Keep the headline price exclusive of the deposit after native variant updates.
        this.section.querySelectorAll('[data-core-base-regular]').forEach(surface => {
          const price = surface.querySelector('[data-price]');
          const regular = surface.querySelector('[data-regular-price]');
          const sale = surface.querySelector('[data-sale-price]');
          if (price) price.classList.toggle('price--on-sale', Boolean(surface.dataset.coreBaseSale));
          if (regular) regular.textContent = surface.dataset.coreBaseRegular;
          if (sale) sale.textContent = surface.dataset.coreBaseSale;
        });
        const returned = this.selectedId !== this.dataset.coreId;
        this.master.value = this.selectedId;
        this.option.value = choice.dataset.option;
        this.querySelectorAll('[data-core-included], [data-core-open]').forEach(node => { node.hidden = returned; });
        this.querySelectorAll('[data-core-returned], [data-core-restore]').forEach(node => { node.hidden = !returned; });
        const sticky = this.section.querySelector('[data-sticky-add-to-cart]');
        const stickyForm = sticky?.querySelector('#form-sticky');
        const right = stickyForm?.querySelector('.sticky-right');
        if (right && !right.querySelector('[data-core-sticky-summary]')) right.prepend(this.querySelector('[data-core-sticky-template]').content.cloneNode(true));
        if (stickyForm && !stickyForm.querySelector('[name="id"]')) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'id';
          stickyForm.append(input);
        }
        this.forms().forEach(form => {
          const input = form.querySelector('[name="id"]');
          if (input) input.value = this.selectedId;
        });
        if (sticky) {
          sticky.querySelectorAll('[data-core-sticky-price]').forEach(node => { node.textContent = choice.dataset.formattedPrice; });
          sticky.querySelectorAll('[data-core-sticky-label]').forEach(node => { node.textContent = choice.dataset.summary; });
          sticky.querySelectorAll('[type="submit"], [data-sticky-btn-addToCart]').forEach(button => {
            button.disabled = choice.dataset.available !== 'true';
            button.setAttribute('aria-disabled', String(button.disabled));
          });
          sticky.setAttribute('data-gems-core-ready', '');
        }
      }
      updateCart(item, formatMoney) {
        const breakdown = this.querySelector('[data-core-cart-breakdown]');
        if (!breakdown) return;
        const quantity = Number(item.quantity);
        const unit = Number(this.dataset.coreUnit);
        const original = Number(item.original_line_price);
        const total = Number(item.final_line_price);
        const deposit = unit * quantity;
        const matches = String(item.variant_id) === this.dataset.coreId;
        const canSplit = matches && Number.isSafeInteger(quantity) && quantity > 0 &&
          Number.isSafeInteger(original) && Number.isSafeInteger(total) && total >= 0 && total <= original &&
          Number(item.original_price) === Number(this.dataset.coreVariantPrice) &&
          !item.selling_plan_allocation && original >= deposit;
        breakdown.hidden = !canSplit;
        this.querySelector('[data-core-cart-included]').hidden = canSplit;
        this.querySelector('[data-core-cart-summary-amount]').hidden = !canSplit;
        if (!canSplit) return;
        const set = (selector, text) => { this.querySelectorAll(selector).forEach(node => { node.textContent = text; }); };
        set('[data-core-cart-item]', formatMoney(original - deposit));
        set('[data-core-cart-charge]', formatMoney(deposit));
        set('[data-core-cart-discount]', '−' + formatMoney(original - total));
        set('[data-core-cart-total]', formatMoney(total));
        set('[data-core-cart-count]', String(quantity));
        this.querySelectorAll('[data-core-cart-quantity]').forEach(node => { node.hidden = quantity <= 1; });
        this.querySelector('[data-core-cart-discount-row]').hidden = original === total;
      }
      disconnectedCallback() { this.dialog?.close(); this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gems-fitment-formatter"] && !Shopify.designMode) return;
  try {
    (function (root) {
  'use strict';
  var YEAR_PATTERN = /\b(?:19\d{2}|20[0-4]\d)\b/g;
  var DETAIL_PATTERN = /^(?:automatic|automatique|manual|manuel|manuelle|dct|smg|cvt|dual[ -]clutch|double[ -]embrayage|awd|fwd|rwd|xdrive|sdrive|\d+(?:[.,]\d+)?\s*l\b|v\d+\b|l\d+\b|i\d+\b|gas\b|diesel\b|electric\b|hybrid\b|hybride\b|flex\b|plug[ -]in\b|mild hybrid\b|full hybrid\b|transmission\s*:|engine\s*:|moteur\s*:|notes?\s*:)/i;
  var NOTE_PATTERN = /^notes?\s*:/i;
  var ELEMENT_SELECTOR = '[data-gems-fitment-grid]';

  function normalizeSource(source) {
    return String(source == null ? '' : source)
      .replace(/\r\n?/g, '\n')
      .replace(/\\n/g, '\n')
      .replace(/\\\s*\n/g, '\n')
      .replace(/\u00a0/g, ' ')
      .replace(/&nbsp;|&#160;|&#x(?:a0|20);/gi, ' ')
      .replace(/<br\s*\/?\s*>|<\/(?:p|div|li|h[1-6])\s*>/gi, '\n')
      .replace(/<li\b[^>]*>/gi, '\n- ')
      .replace(/<\/?(?:strong|em|b|i|p|div|ul|ol|h[1-6])\b[^>]*>/gi, '');
  }

  function cleanText(source) {
    return String(source == null ? '' : source)
      .replace(/[\u200b-\u200d\ufeff]/g, '')
      .replace(/^\s*#{1,6}\s+/, '')
      .replace(/^\s*(?:[-•]\s+|\*\s+)/, '')
      .replace(/\*\*/g, '')
      .replace(/\\\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function findYearStarts(line) {
    var result = [];
    var match;
    YEAR_PATTERN.lastIndex = 0;

    while ((match = YEAR_PATTERN.exec(line)) !== null) {
      var index = match.index;
      var before = line.slice(0, index);
      var after = line.slice(index + 4);
      var previous = before.slice(-1);
      var following = after.trimStart();

      if (previous === '/' || previous === '(') continue;
      if (/\b(?:19\d{2}|20\d{2})\s*[-–—/]\s*$/.test(before)) continue;
      if (/\bnotes?\s*:/i.test(before)) continue;
      if (!/^\s*(?:\S|$)/.test(after)) continue;
      if (/(?:from|through|since|until|before|after|between|model\s+years?)\s*$/i.test(before)) continue;
      if (following && !/^\S/.test(following)) continue;

      result.push(index);
    }
    return result;
  }

  function parseFitment(source) {
    var rows = normalizeSource(source).split('\n');
    var groups = [];
    var current = null;

    function setGroup(title) {
      var name = cleanText(title).replace(/\s*[:–—-]\s*$/, '');
      if (!name) return;
      if (current && current.title.toLowerCase() === name.toLowerCase()) return;
      current = { title: name, entries: [] };
      groups.push(current);
    }

    function addEntry(text) {
      var value = cleanText(text);
      if (!value) return;
      if (!current) {
        current = { title: '', entries: [] };
        groups.push(current);
      }
      current.entries.push(value);
    }

    function appendDetail(text) {
      var value = cleanText(text);
      if (!value) return;
      if (!current || current.entries.length === 0) {
        addEntry(value);
        return;
      }
      var last = current.entries.length - 1;
      current.entries[last] += (NOTE_PATTERN.test(value) ? ' — ' : ' ') + value;
    }

    rows.forEach(function (rawRow) {
      var row = cleanText(rawRow);
      if (!row) return;

      if (NOTE_PATTERN.test(row)) {
        appendDetail(row);
        return;
      }

      var positions = findYearStarts(row);
      if (positions.length) {
        var prefix = cleanText(row.slice(0, positions[0]));
        if (prefix && !DETAIL_PATTERN.test(prefix)) setGroup(prefix);
        else if (prefix) appendDetail(prefix);

        positions.forEach(function (start, index) {
          var end = index + 1 < positions.length ? positions[index + 1] : row.length;
          addEntry(row.slice(start, end));
        });
        return;
      }

      if (DETAIL_PATTERN.test(row) || /^\s{2,}\S/.test(rawRow)) {
        appendDetail(row);
      } else if (/^\s*[-•]\s+/.test(rawRow) && current && current.entries.length) {
        addEntry(row);
      } else {
        setGroup(row);
      }
    });

    var withData = groups.map(function (group) {
      return group.entries.length ? group : { title: '', entries: [group.title] };
    });
    if (withData.length) return withData;

    var remainder = cleanText(normalizeSource(source));
    return remainder ? [{ title: '', entries: [remainder] }] : [];
  }

  var FIELDS = ['year', 'make', 'model', 'engine', 'transmission'];
  var SELECTOR_ROOT = '.easysearch-widget, .easysearch-embed-widget-main, [data-easysearch-root]';
  var STORE_KEY = 'gems_active_vehicle_v1';
  var INSTANCES = new WeakMap();
  var serial = 0;

  function norm(value) {
    return String(value == null ? '' : value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }
  function key(value) { return norm(value).replace(/[^a-z0-9]/g, ''); }
  function canonical(field, value) {
    var clean = String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
    return field === 'transmission' ? clean.replace(/^(.+?)\s*\(\s*(\d+)\s*Speed\s*\)$/i, '$1 $2-spd')
      .replace(/^(.+?)\s+(\d+)\s+Speed$/i, '$1 $2-spd') : clean;
  }
  function validVehicle(vehicle) {
    return !!vehicle && /^(19|20)\d{2}$/.test(String(vehicle.year)) && FIELDS.every(function (field) {
      var value = norm(vehicle[field]);
      return value && !/^(select|choose|choisir|selectionner)\b/.test(value) &&
        !/^(year|make|model|engine|transmission|annee|marque|modele|moteur|null|undefined)$/.test(value);
    });
  }
  function signature(vehicle) {
    return validVehicle(vehicle) ? FIELDS.map(function (field) { return norm(canonical(field, vehicle[field])); }).join('|') : '';
  }
  function tagState(tags, vehicle) {
    if (!validVehicle(vehicle)) return null;
    function tagKey(value) { return String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase(); }
    var all = (tags || []).map(tagKey);
    if (!all.some(function (tag) { return /^(year|make|model|engine|transmission)\s*:/.test(tag); })) return 'unknown';
    return FIELDS.every(function (field) {
      return all.indexOf(tagKey(field + ':' + canonical(field, vehicle[field]))) !== -1;
    }) ? 'success' : 'fail';
  }
  function transmission(value) {
    var text = norm(value).replace(/[‐‑‒–—]/g, '-').replace(/\b(smg|dct|dsg|pdk|cvt)(\d{1,2})\b/g, '$1 $2-spd'), family = '';
    if (/\b(smg|sequential manual|automated manual|amt)\b/.test(text)) family = 'smg';
    else if (/\b(dct|dsg|pdk|dual[ -]clutch|double[ -]embrayage|s[ -]?tronic)\b/.test(text)) family = 'dct';
    else if (/\b(cvt|continuously variable|variation continue|multitronic)\b/.test(text)) family = 'cvt';
    else if (/\b(manual|manuel|manuelle|m\s*\/\s*t|mt)\b|\b(?:\d{1,2}\s*mt|mt\d{1,2})\b/.test(text)) family = 'manual';
    else if (/\b(automatic|automatique|auto|a\s*\/\s*t|at|tiptronic|steptronic)\b|\b(?:\d{1,2}\s*at|at\d{1,2})\b|\b(?:zf\s*)?\d{1,2}hp\d*/.test(text)) family = 'automatic';
    var speed = text.match(/\b(\d{1,2})\s*[- ]?(?:spd|speed|vitesses?|rapports?)\b/) ||
      text.match(/\b(\d{1,2})\s*(?:at|mt)\b/) || text.match(/\b(?:at|mt)\s*[- ]?(\d{1,2})\b/) ||
      text.match(/\b(?:zf\s*)?(\d{1,2})hp\d*/);
    return { family: family, speed: speed ? speed[1] : '' };
  }
  function transmissionMatch(selected, listed) {
    var wanted = transmission(selected), actual = transmission(listed);
    if (!wanted.family || !actual.family) return 'unknown';
    if (wanted.speed && actual.speed && wanted.speed !== actual.speed) return 'different';
    if (wanted.family === actual.family) return 'match';
    if (wanted.family === 'manual' || actual.family === 'manual') return 'different';
    return wanted.family === 'automatic' || actual.family === 'automatic' ? 'match' : 'different';
  }
  function engine(value) {
    var text = norm(value).replace(/(\d),(\d)/g, '$1.$2')
      .replace(/\b(?:inline|in-line|straight|en ligne)\s*[- ]?(\d{1,2})\b/g, 'i$1')
      .replace(/\b(?:flat|boxer|a plat)\s*[- ]?(\d{1,2})\b/g, 'h$1')
      .replace(/\b([vliwh])\s*[- ]\s*(\d{1,2})\b/g, '$1$2')
      .replace(/\b(\d+(?:\.\d+)?)\s*[- ]?\s*(?:litres?|liters?)\b/g, '$1l')
      .replace(/\b([bmns]\d{2})\s+([abdmt]\d{2}[a-z0-9]*)\b/g, '$1$2');
    var identity = text.search(/\b\d+(?:\.\d+)?\s*l\b|\b\d+\.\d+\b|\b[vliwh]\d{1,2}\b/);
    if (/^(?:19|20)\d{2}\b/.test(text) && identity !== -1) text = text.slice(identity);
    var capacity = text.match(/\b(\d+(?:\.\d+)?)\s*l\b/) || text.match(/\b(\d+\.\d+)\b/);
    var cylinders = text.match(/\b([vliwh])(\d{1,2})\b/);
    var cylinderCount = text.match(/\b(\d{1,2})\s*[- ]?(?:cyl|cylinders?|cylindres?)\b/);
    var ignored = /^(?:v|l|i|w|h)\d+$|^gen\d+$|^(?:awd|rwd|fwd|4wd|4x4|smg|dct|dsg|pdk|cvt|at|mt|ts[i]?|tfsi|fsi|tdi|gdi|dohc|sohc|ohv|ohc|vvt|vtec|gas|gasoline|petrol|essence|diesel|electric|electrique|hybrid|hybride|mild|full|phev|mhev|fhev|bev|ev|plug|in|turbo|turbocharged|supercharged|twin|twinpower|bi|biturbo|twin-turbo|naturally|aspirated|carbureted|injection|direct|port|mpfi|sfi|l|litre|litres|liter|liters|engine|moteur|code|generation|gen|automatic|automatique|manual|manuel|manuelle|auto|transmission|spd|speed|speeds|vitesses|rapports|rwd|xdrive|sdrive|quattro|4matic|fwd|sedan|saloon|coupe|wagon|estate|sport|utility|suv|mpv|hatchback|convertible|cabriolet|cabrio|roadster|touring|pickup|truck|van|passenger|door|doors|valve|valves|cylinder|cylinders|cyl|cilindres|cylindres|bmw|audi|mini|volvo|porsche|volkswagen|mercedes|benz)$/;
    var codes = (text.match(/\b[a-z]{1,5}\d{1,5}[a-z0-9]*(?:[.-]\d{1,4})?\b|\b(?:\d[a-z]{2,4}[a-z0-9]*|\d[a-z]\d[a-z0-9]*)(?:-[a-z0-9]+)?\b|\b[a-z]{3,6}\b/g) || []).filter(function (code) {
      return !ignored.test(code) && !/^(?:fuel|flex|flexible|ethanol|cng|lpg|fueled|fuelled)$/.test(code);
    });
    var generation = text.match(/\bgen(?:eration)?\s*(\d+)\b/);
    var fuel = /\b(diesel|tdi)\b/.test(text) ? 'diesel' : /\b(gas|gasoline|petrol|essence|tfsi|tsi|fsi)\b/.test(text) ? 'gas' :
      /\b(electric|electrique|bev)\b/.test(text) ? 'electric' : '';
    var induction = /\b(supercharged|supercharger|supercharge)\b/.test(text) ? 'supercharged' :
      /\b(turbo|turbocharged|turbocharge|biturbo|tfsi|tsi|tdi)\b/.test(text) ? 'turbo' :
      /\bnaturally aspirated\b|\batmospherique\b/.test(text) ? 'natural' : '';
    return { capacity: capacity ? Number(capacity[1]) : null,
      cylinders: cylinders ? (/[li]/.test(cylinders[1]) ? 'i' : cylinders[1]) + cylinders[2] : cylinderCount ? 'c' + cylinderCount[1] : '',
      codes: Array.from(new Set(codes)), generation: generation ? generation[1] : '', fuel: fuel, induction: induction };
  }
  function sameEngineCode(left, right) {
    var a = key(left), b = key(right);
    if (a === b) return true;
    var short = a.length < b.length ? a : b, long = a.length < b.length ? b : a;
    var longRaw = a.length < b.length ? right : left;
    if (!/^(?:[a-z]{1,5}\d{2,5}|\d[a-z]{2,4})$/.test(short) || long.indexOf(short) !== 0) return false;
    var rest = long.slice(short.length);
    return /^[a-z]/.test(rest) || norm(longRaw).indexOf(short + '.') === 0;
  }
  function engineMatch(selected, listed) {
    var wanted = engine(selected), actual = engine(listed), evidence = false, conflict = false;
    ['capacity', 'cylinders', 'generation', 'fuel', 'induction'].forEach(function (field) {
      if (wanted[field] === null || wanted[field] === '' || actual[field] === null || actual[field] === '') return;
      var equal = wanted[field] === actual[field];
      if (field === 'cylinders' && (wanted[field][0] === 'c' || actual[field][0] === 'c')) equal = wanted[field].slice(1) === actual[field].slice(1);
      if (!equal) conflict = true;
      else if (field === 'capacity' || field === 'cylinders' || (field === 'fuel' && wanted[field] === 'electric')) evidence = true;
    });
    if (wanted.codes.length && actual.codes.length) {
      var codeMatch = wanted.codes.some(function (code) {
        return actual.codes.some(function (other) { return sameEngineCode(code, other); });
      });
      if (codeMatch) evidence = true;
      else conflict = true;
    }
    return conflict ? 'different' : evidence ? 'match' : 'unknown';
  }
  function modelIdentity(value) {
    return key(norm(value).replace(/\bvw\b/g, 'volkswagen').replace(/\bchevy\b/g, 'chevrolet')
      .replace(/\bmercedes[- ]benz\b/g, 'mercedes')
      .replace(/\s*\((?:[a-z]{1,3}\d{1,3}[a-z]?(?:\.\d+)?)(?:\s*\/\s*[a-z]{1,3}\d{1,3}[a-z]?(?:\.\d+)?)*\)\s*$/i, ''));
  }
  function rowMatch(group, entry, vehicle) {
    var line = norm(entry).replace(/^[✓✔]\s*/, '');
    var year = line.match(/^(19\d{2}|20\d{2})(?:\s*[-–—/]\s*(\d{4}|\d{2}))?\b/);
    var wanted = modelIdentity(vehicle.make + ' ' + vehicle.model);
    var heading = modelIdentity(group);
    var modelMatch = heading === wanted;
    if (!group && year) {
      var afterYear = line.slice(year[0].length).trim();
      var detailStart = afterYear.search(/\b(?:automatic|automatique|manual|manuel|manuelle|dct|smg|cvt)\b/i);
      if (detailStart > 0) modelMatch = modelIdentity(afterYear.slice(0, detailStart)) === wanted;
    }
    if (!modelMatch || !year) return { eligible: false, rank: -1 };
    var startYear = Number(year[1]);
    var endYear = year[2] ? Number(year[2].length === 2 ? year[1].slice(0, 2) + year[2] : year[2]) : startYear;
    if (endYear < startYear || endYear > 2099) return { eligible: false, rank: -1 };
    var sameYear = Number(vehicle.year) >= startYear && Number(vehicle.year) <= endYear;
    var mainLine = line.split(/\bnotes?\s*:|\s—\s/i)[0];
    var eng = engineMatch(vehicle.engine, mainLine);
    var trans = transmissionMatch(vehicle.transmission, mainLine);
    var restricted = /\b(?:notes?|except|excluding|excludes|only|without|with|not for|up to|from|through|before|after|jusqu|sauf|uniquement|sans|avec)\b|\b\d{1,2}\/\d{4}\b/i.test(line);
    var exact = sameYear && eng === 'match' && trans === 'match';
    var distance = sameYear ? 0 : Math.min(Math.abs(startYear - Number(vehicle.year)), Math.abs(endYear - Number(vehicle.year)));
    return { eligible: true, exact: exact, review: exact && restricted,
      rank: (sameYear ? 100 : 30 / (1 + distance)) + (eng === 'match' ? 20 : 0) + (trans === 'match' ? 10 : 0),
      sameYear: sameYear, engine: eng, transmission: trans };
  }
  function broadScope(raw, tags) {
    var text = norm(cleanText(normalizeSource(raw))).replace(/[.!]+$/, '');
    var all = (tags || []).map(norm);
    if (all.indexOf('not vehicle related') !== -1) return { type: 'neutral' };
    if (all.indexOf('fitment:universal') !== -1 || /^(?:fits all vehicles|for all vehicles|universal fitment|universal fit|convient a tous les vehicules|pour tous les vehicules)$/.test(text)) return { type: 'universal' };
    if (/^fits all bmws?(?: and minis?)?$/.test(text)) return { type: 'make', makes: /mini/.test(text) ? ['bmw', 'mini'] : ['bmw'] };
    if (/^fits all minis?$/.test(text)) return { type: 'make', makes: ['mini'] };
    return null;
  }
  function assess(groups, raw, tags, vehicle, checker, selecting) {
    var scope = broadScope(raw, tags), rows = [];
    groups.forEach(function (group) { group.entries.forEach(function (entry) { rows.push({ group: group.title, entry: entry }); }); });
    var result = { state: 'no_vehicle', tone: 'neutral', rows: rows, selected: [], similar: false };
    var hasDetailedRows = rows.some(function (row) { return /^(?:[✓✔]\s*)?(19|20)\d{2}\b/.test(row.entry); });
    if (scope && scope.type === 'neutral') { result.state = 'neutral'; return result; }
    if (selecting) { result.state = 'selecting'; return result; }
    if (scope && scope.type === 'universal' && hasDetailedRows) {
      result.state = 'data_conflict'; result.tone = 'amber'; return result;
    }
    if (scope && scope.type === 'universal' && (!validVehicle(vehicle) || checker !== 'fail')) { result.state = 'universal'; return result; }
    if (!validVehicle(vehicle)) return result;
    if (scope) {
      result.state = scope.type === 'make' && scope.makes.indexOf(norm(vehicle.make)) === -1 ? 'scope_other' :
        checker === 'fail' ? 'conflict' : scope.type === 'universal' ? 'universal' : 'scope';
      if (result.state === 'scope_other' && checker === 'success') result.state = 'conflict';
      result.tone = result.state === 'scope_other' ? 'red' : result.state === 'conflict' ? 'amber' : 'neutral';
      return result;
    }
    rows.forEach(function (row, index) { row.match = rowMatch(row.group, row.entry, vehicle); row.index = index; });
    var exact = rows.filter(function (row) { return row.match.exact; });
    var cleanExact = exact.filter(function (row) { return !row.match.review; });
    if (exact.length) {
      result.state = checker === 'fail' ? 'conflict' : cleanExact.length ? 'exact' : 'review';
      result.tone = result.state === 'exact' ? 'green' : 'amber';
      result.selected = exact.map(function (row) { return row.index; });
      return result;
    }
    var similar = rows.filter(function (row) { return row.match.eligible; }).sort(function (a,b) { return b.match.rank - a.match.rank || a.index - b.index; });
    result.selected = similar.map(function (row) { return row.index; });
    result.similar = similar.length > 0;
    result.state = checker === 'success' ? 'selector' : !hasDetailedRows ? 'no_data' : similar.some(function (row) {
      return row.match.sameYear && row.match.engine !== 'different' && row.match.transmission !== 'different';
    }) ? 'review' : 'no_match';
    result.tone = result.state === 'no_match' ? 'red' : result.state === 'no_data' ? 'neutral' : 'amber';
    return result;
  }
  var VERSION = '0.3.8';
  var activeVehicle = null, selecting = false, cleared = false, editingRoot = null;
  var pending = null, observer = null, stopped = false, listeners = [], timers = [];

  function textNode(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function label(instance, name) { return instance.labels[name] || ''; }
  function readVehicle() {
    if (root.__GEMS_COLLECTION_FITMENT_DISABLED__ === true) return null;
    try {
      if (root.GEMS && typeof root.GEMS.getActiveVehicle === 'function') {
        var live = root.GEMS.getActiveVehicle();
        if (validVehicle(live)) return live;
      }
    } catch (error) {}
    // Use the same saved vehicle as the product checker while the bridge starts.
    try {
      var stored = JSON.parse(root.localStorage.getItem(STORE_KEY) || 'null');
      if (validVehicle(stored)) return stored;
    } catch (error) {}
    return root.GEMS && validVehicle(root.GEMS.activeVehicle) ? root.GEMS.activeVehicle : null;
  }
  function readSelector(widget) {
    if (!widget) return null;
    var selects = widget.querySelectorAll('select'), vehicle = {};
    if (selects.length < FIELDS.length) return null;
    for (var i = 0; i < FIELDS.length; i++) { if (selects[i].disabled) return null; }
    FIELDS.forEach(function (field, index) {
      var select = selects[index];
      var option = select.selectedOptions && select.selectedOptions[0] || select.options[select.selectedIndex];
      vehicle[field] = canonical(field, option && option.textContent || select.value || '');
    });
    return validVehicle(vehicle) ? vehicle : null;
  }
  function vehicleControl(grid) {
    if (!root.GEMSProductShortcuts && !root.GEMSFitmentShortcut) return null;
    var section = grid.closest('.product_template') || document.querySelector('#MainContent .product_template') || document.querySelector('.product_template');
    if (!section) return null;
    return section.querySelector('[data-gems-product-services] [data-gems-fitment-target], .product_services [data-gems-fitment-target]');
  }
  function orderCards(instance, selected) {
    var promoted = new Set(selected.map(function (index) { return instance.rowCards[index]; }));
    var ordered = instance.cards.filter(function (card) { return promoted.has(card); })
      .concat(instance.cards.filter(function (card) { return !promoted.has(card); }));
    var cursor = instance.summary.nextElementSibling, changed = false;
    var focused = document.activeElement;
    ordered.forEach(function (card) {
      if (card === cursor) cursor = cursor.nextElementSibling;
      else { instance.grid.insertBefore(card, cursor); changed = true; }
    });
    if (changed && focused && instance.grid.contains(focused) && document.activeElement !== focused) focused.focus({ preventScroll: true });
    if (changed) {
      instance.animations.forEach(function (animation) { animation.cancel(); });
      instance.animations = [];
      var reduced = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (instance.ordered && !reduced) ordered.forEach(function (card) {
        if (promoted.has(card) && typeof card.animate === 'function' && card.getClientRects().length) {
          instance.animations.push(card.animate([{ opacity: 0.7, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 180, easing: 'ease-out' }));
        }
      });
    }
    instance.ordered = true;
  }
  function mount(grid) {
    if (INSTANCES.has(grid)) return INSTANCES.get(grid);
    var holder = grid.querySelector('[data-gems-fitment-source]');
    var configNode = grid.querySelector('[data-gems-fitment-config]');
    if (!holder || !configNode) return null;
    var config;
    try { config = JSON.parse(configNode.textContent); } catch (error) { return null; }
    var raw = holder.textContent || '', groups = parseFitment(raw);
    var instance = { grid: grid, raw: raw, groups: groups, tags: Array.isArray(config.tags) ? config.tags : [],
      labels: config.labels || {}, rows: [], badges: [], cards: [], rowCards: [], animations: [], ordered: false, last: '' };
    var fragment = document.createDocumentFragment();
    fragment.appendChild(holder);
    fragment.appendChild(configNode);

    var summary = textNode('div', 'gff-summary');
    var live = textNode('div', 'gff-live');
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('aria-atomic', 'true');
    instance.icon = textNode('span', 'gff-icon');
    instance.icon.setAttribute('aria-hidden', 'true');
    var copy = textNode('div', 'gff-copy');
    instance.title = textNode('h4', 'gff-title');
    instance.vehicle = textNode('p', 'gff-vehicle');
    instance.detail = textNode('p', 'gff-detail');
    instance.similar = textNode('p', 'gff-similar');
    copy.append(instance.title, instance.vehicle, instance.detail, instance.similar);
    live.append(instance.icon, copy);
    var actions = textNode('div', 'gff-actions');
    instance.change = textNode('button', 'gff-button gff-button-secondary');
    instance.change.type = 'button';
    instance.change.addEventListener('click', function () {
      var control = vehicleControl(instance.grid);
      if (!control) return;
      control.click();
    });
    actions.append(instance.change);
    instance.actions = actions;
    summary.append(live, actions);
    instance.summary = summary;
    fragment.appendChild(summary);

    groups.forEach(function (data) {
      var group = textNode('div', 'gems-fitment-group notranslate');
      instance.cards.push(group);
      group.setAttribute('translate', 'no');
      if (data.title) group.appendChild(textNode('h5', 'gems-fitment-heading notranslate', data.title));
      var list = textNode('ul', 'gems-fitment-list notranslate');
      data.entries.forEach(function (entry) {
        var row = textNode('li', 'notranslate');
        row.setAttribute('translate', 'no');
        row.setAttribute('tabindex', '-1');
        row.id = 'gff-entry-' + (++serial);
        var content = textNode('span', 'gff-entry-text', entry);
        var badge = textNode('span', 'gff-row-badge');
        badge.hidden = true;
        row.append(content, badge);
        instance.rows.push(row);
        instance.rowCards.push(group);
        instance.badges.push(badge);
        list.appendChild(row);
      });
      group.appendChild(list);
      fragment.appendChild(group);
    });
    if (!groups.length) fragment.appendChild(textNode('p', 'gff-empty', label(instance, 'no_rows')));
    grid.replaceChildren(fragment);
    grid.setAttribute('data-gems-fitment-rendered', 'true');
    grid.setAttribute('data-gff-ready', VERSION);
    INSTANCES.set(grid, instance);
    return instance;
  }
  function update(instance) {
    var control = vehicleControl(instance.grid);
    var stamp = [signature(activeVehicle), selecting, !!control].join(';');
    if (stamp === instance.last) return;
    var checker = tagState(instance.tags, activeVehicle);
    var result = assess(instance.groups, instance.raw, instance.tags, activeVehicle, checker, selecting);
    instance.last = stamp;
    instance.grid.setAttribute('data-gff-state', result.state);
    instance.summary.setAttribute('data-tone', result.tone);
    instance.icon.textContent = result.tone === 'green' ? '✓' : result.tone === 'amber' || result.tone === 'red' ? '!' : 'i';
    instance.title.textContent = label(instance, result.state + '_title');
    instance.detail.textContent = label(instance, result.state + '_detail');
    instance.vehicle.hidden = !validVehicle(activeVehicle);
    instance.vehicle.textContent = validVehicle(activeVehicle) ? label(instance, 'selected_vehicle') + ': ' +
      FIELDS.map(function (field) { return canonical(field, activeVehicle[field]); }).join(' · ') : '';
    instance.similar.hidden = !result.similar || result.state === 'no_match';
    instance.similar.textContent = label(instance, 'similar_intro');
    instance.change.hidden = !control || result.state === 'neutral';
    instance.actions.hidden = instance.change.hidden;
    instance.change.textContent = label(instance, validVehicle(activeVehicle) ? 'change_vehicle' : 'select_vehicle');
    instance.rows.forEach(function (row, index) {
      var selected = result.selected.indexOf(index) !== -1;
      var match = result.rows[index].match;
      var green = selected && result.tone === 'green' && match && !match.review;
      row.removeAttribute('data-gff-match');
      instance.badges[index].hidden = !selected;
      instance.badges[index].textContent = selected ? label(instance, green ? 'row_match' : result.similar ? 'row_similar' : 'row_review') : '';
      if (selected) row.setAttribute('data-gff-match', green ? 'exact' : 'review');
    });
    orderCards(instance, result.selected);
  }
  function renderAll() {
    if (stopped) return;
    document.querySelectorAll(ELEMENT_SELECTOR).forEach(function (grid) {
      var instance = mount(grid);
      if (instance) update(instance);
    });
  }
  function schedule() {
    if (pending !== null || stopped) return;
    pending = root.setTimeout(function () { pending = null; sync(); }, 0);
  }
  function sync() {
    if (editingRoot && editingRoot.isConnected) {
      activeVehicle = readSelector(editingRoot);
      selecting = !activeVehicle;
    } else {
      editingRoot = null;
      selecting = false;
      activeVehicle = cleared ? null : readVehicle();
    }
    renderAll();
  }
  function later(fn, delay) { timers.push(root.setTimeout(function () { if (!stopped) fn(); }, delay)); }
  function on(target, type, callback, options) {
    target.addEventListener(type, callback, options);
    listeners.push(function () { target.removeEventListener(type, callback, options); });
  }
  function clear() {
    cleared = true; editingRoot = null; selecting = false; activeVehicle = null;
    renderAll();
  }
  function activeChange(event) {
    if (!validVehicle(event.detail)) { clear(); return; }
    if (editingRoot && editingRoot.isConnected) {
      var chosen = readSelector(editingRoot);
      if (!chosen || signature(chosen) !== signature(event.detail)) { sync(); return; }
      editingRoot = null;
    }
    cleared = false; selecting = false; activeVehicle = event.detail;
    renderAll();
  }
  function boot() {
    // Listen before the first read: selection and reset can arrive during parsing.
    on(document, 'gems:active-vehicle-change', activeChange);
    on(document, 'gems:product-fitment-verified', function () { sync(); });
    on(document, 'gems:easysearch-fitment-reset', clear);
    on(document, 'change', function (event) {
      var select = event.target;
      if (!select || select.tagName !== 'SELECT') return;
      var widget = select.closest(SELECTOR_ROOT);
      if (!widget) return;
      // App hydration dispatches changes too. Only a real selection starts an
      // edit; subsequent synthetic cascading changes stay inside that edit.
      if (event.isTrusted !== true) { sync(); schedule(); return; }
      editingRoot = widget; cleared = false; activeVehicle = null; selecting = true;
      renderAll();
      later(sync, 0); later(sync, 150); later(sync, 400);
    }, true);
    on(document, 'click', function (event) {
      var target = event.target && event.target.closest && event.target.closest('.easysearch-btn-clean, .easysearch-reset-btn, [data-es-clear]');
      if (target) clear();
    }, true);
    on(root, 'storage', function (event) {
      if (event.key !== STORE_KEY) return;
      editingRoot = null;
      if (!event.newValue) { clear(); return; }
      try { activeChange({ detail: JSON.parse(event.newValue) }); } catch (error) { clear(); }
    });
    on(root, 'pageshow', function (event) {
      if (event.persisted) { cleared = false; editingRoot = null; }
      sync();
    });
    ['shopify:section:load', 'easysearch_ready', 'gems:search-fitment-hydrated', 'gems:localized-fitment-hydrated'].forEach(function (type) {
      on(document, type, function () { sync(); schedule(); });
    });
    if (root.MutationObserver && document.documentElement) {
      observer = new root.MutationObserver(function (changes) {
        var relevant = changes.some(function (change) {
          if (change.target.nodeType === 1 && change.target.closest(ELEMENT_SELECTOR)) return false;
          if (change.target.nodeType === 1 && change.target.closest(SELECTOR_ROOT)) return true;
          return Array.prototype.some.call(change.addedNodes || [], function (node) {
            var selector = ELEMENT_SELECTOR + ', [data-gems-fitment-target], ' + SELECTOR_ROOT;
            return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
          });
        });
        if (relevant) schedule();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true,
        attributes: true, attributeFilter: ['disabled', 'selected', 'value'] });
    }
    if (document.readyState === 'loading') on(document, 'DOMContentLoaded', sync, { once: true });
    sync();
    later(sync, 250); later(sync, 1000);
  }
  var api = { version: VERSION, parse: parseFitment, assess: assess, tagState: tagState,
    renderAll: renderAll, destroy: function () {
      stopped = true;
      listeners.forEach(function (remove) { remove(); });
      timers.forEach(function (timer) { root.clearTimeout(timer); });
      if (pending !== null) root.clearTimeout(pending);
      if (observer) observer.disconnect();
    } };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document === 'undefined') return;
  if (root.GEMSFitmentFormatter && root.GEMSFitmentFormatter.version === VERSION) {
    root.GEMSFitmentFormatter.renderAll(); return;
  }
  if (root.GEMSFitmentFormatter && typeof root.GEMSFitmentFormatter.destroy === 'function') root.GEMSFitmentFormatter.destroy();
  root.GEMSFitmentFormatter = api;
  boot();
})(typeof window !== 'undefined' ? window : globalThis);
  } catch(e) { console.error(e); }
})();

})();
